import styled from "@emotion/styled";

import ImageBubbleLargeDesktop from "./bubble-large-desktop.svg?url";
import ImageBubble from "./bubble.svg?url";

export const Container = styled.div`
  position: relative;
  inset-block-start: -32px;
  z-index: 3;

  display: flex;
  justify-content: center;
  align-items: flex-end;

  ${props => props.theme.breakpoints.up("tablet")} {
    inset-block-start: 0;

    margin-block-end: 18px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    margin-block-end: 48px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    position: absolute;
    inset-block-start: -173px;
    inset-inline-start: -216px;

    flex-direction: column-reverse;
    justify-content: flex-start;
    align-items: center;

    margin-block-end: 0;
  }
`;

export const PeterImageContainer = styled.div`
  position: relative;
  z-index: 1;

  inline-size: 98.4px;
  block-size: 160.8px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 131.2px;
    block-size: 214.4px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    inline-size: 164px;
    block-size: 268px;
  }
`;

export const StyledImage = styled.img`
  inline-size: 100%;
  block-size: 100%;
`;

export const Bubble = styled.div`
  position: relative;

  inline-size: 125px;
  block-size: 113px;
  margin-inline-start: -30px;

  background-image: url(${ImageBubble});
  background-repeat: no-repeat;
  background-size: contain;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 167px;
    block-size: 151px;
    margin-inline-start: -40px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    inline-size: 200px;
    block-size: 182px;
    margin-block-end: -55px;
    margin-inline-start: 0;

    background-image: url(${ImageBubbleLargeDesktop});
  }
`;
